export default function getBackendUrl(): string {
    if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1') || window.location.host.includes('delivereka')) {
        return 'https://backend.dev.heurekaprints.de/'
    }
    return '/backend/'
}